import styled from 'styled-components';
import { useCommunities } from '@/hooks';
import { filterCommunities } from './filterExplore';
import { DiscoveryCommunityCard } from './DiscoveryCommunityCard';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 190px), 1fr));
  gap: 12px;
`;
const Empty = styled.div`
  padding: 28px 16px;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;
export interface CommunityResultsProps {
  search: string;
}
export function CommunityResults({ search }: CommunityResultsProps) {
  const { communities } = useCommunities();
  const visible = filterCommunities(communities, search);
  if (!visible.length)
    return (
      <Empty>{search.trim() ? 'No communities match your search.' : 'No communities yet.'}</Empty>
    );
  return (
    <Grid>
      {visible.map((community) => (
        <DiscoveryCommunityCard key={community.id} community={community} />
      ))}
    </Grid>
  );
}
